/** Main header nav landmark; must match `MenuToggle` `aria-controls` and mobile CSS targets. */
export const HEADER_NAV_REGION_ID = 'navLinks' as const;
